import { makeObservable } from "mobx";
import { FormStore } from "@roc/feature-app-core";
import { GlobalStore } from "@roc/feature-app-core";

const form = {
  fields: {
    templateId: {
      value: 0,
      error: null,
      rule: '',
      message: '',
    },
    sendTo: {
      value: [],
      error: null,
      rule: '',
      message: '',
    },
    subject: {
      value: '',
      error: null,
      rule: '',
      message: '',
    },
    contentText: {
      value: '',
      error: null,
      rule: '',
      message: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class SendBulkEmailFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
    makeObservable(this, {
    });
  }
  onFieldChange(field, value) {
    if (field === 'objectType') {
      this.form.fields.recordType.value = null;
    }
    super.onFieldChange(field, value);
  }
}
